/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './feature-components/loading-spinner/loading-spinner.component.ngfactory';
import * as i3 from '../../app/feature-components/loading-spinner/loading-spinner.component';
import * as i4 from '@angular/router';
import * as i5 from '../../app/app.component';
import * as i6 from '../../app/common-services/common-function.service';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-loading-spinner',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_LoadingSpinnerComponent_0,
      i2.RenderType_LoadingSpinnerComponent)),i1.ɵdid(1,114688,(null as any),0,i3.LoadingSpinnerComponent,
      ([] as any[]),{isLoading:[0,'isLoading']},(null as any)),(_l()(),i1.ɵted(-1,
      (null as any),['\n'])),(_l()(),i1.ɵeld(3,16777216,(null as any),(null as any),
      1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(4,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
      i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
      (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,
      _v) => {
    var _co:i5.AppComponent = _v.component;
    const currVal_0:any = _co.isLoadingSpinner;
    _ck(_v,1,0,currVal_0);
    _ck(_v,4,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(1,245760,(null as any),0,i5.AppComponent,[i6.CommonFunctionService],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i5.AppComponent> = i1.ɵccf('app-root',
    i5.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9vcHQvamVua2lucy93b3Jrc3BhY2UvZ2lzZWxhX3BvcnRhbC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9vcHQvamVua2lucy93b3Jrc3BhY2UvZ2lzZWxhX3BvcnRhbC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXBwLWxvYWRpbmctc3Bpbm5lciBbbG9hZGluZ109XCJpc0xvYWRpbmdTcGlubmVyXCI+PC9hcHAtbG9hZGluZy1zcGlubmVyPlxuPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuPCEtLSA8ZGl2IHVpLXZpZXc9XCJtYWluXCIgc3R5bGU9XCJoZWlnaHQ6MTAwJTtcIj48L2Rpdj4gLS0+IiwiPGFwcC1yb290PjwvYXBwLXJvb3Q+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBOzJDQUFBLFVBQUE7TUFBQSx5REFBd0U7TUFBQSx1QkFDeEU7TUFBQTtNQUFBLHVCQUFBO3NEQUFBO01BQUEsNkJBQStCOzs7SUFEVjtJQUFyQixXQUFxQixTQUFyQjtJQUNBOzs7O29CQ0RBO01BQUE7YUFBQTtVQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts